module.exports = __webpack_public_path__ + "img/thank-img-hoverlogo0.97a73877.png";